import { ControllerRenderProps } from "react-hook-form";
import MultipleSelector, { Option } from "@/components/ui/multiple-selector";
import { CountryResponse } from "@/generated-api";
import { useGetCountries } from "@/tanstack-hooks";
import Spinner from "@/components/Spinner";
import { formatNationality } from "@/lib/utils";

export default function NationalitySelector({
  formField,
  maxSelections = 1,
  placeholder = "Search",
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formField: ControllerRenderProps<any>;
  maxSelections?: number;
  placeholder?: string;
}) {
  const countriesQuery = useGetCountries();

  if (countriesQuery.isLoading) {
    return <Spinner />;
  }

  const countries = countriesQuery.data as CountryResponse[];

  const mappedOptions: Option[] = countries.map((country: CountryResponse) => ({
    label: formatNationality(country),
    value: formatNationality(country),
    id: country.id,
  }));

  return (
    <MultipleSelector
      {...formField}
      options={mappedOptions}
      maxSelected={maxSelections}
      placeholder={placeholder}
      hidePlaceholderWhenSelected={true}
      loadingIndicator={
        <p className="py-2 text-center leading-10 text-muted-foreground">
          searching...
        </p>
      }
      emptyIndicator={
        <p className="text-center leading-10 text-gray-600 dark:text-gray-400">
          No results, type to search.
        </p>
      }
    />
  );
}
